import React, { useState } from "react";
import { Link } from "react-router-dom";
import { Drawer, Form, Icon, Checkbox, Collapse, notification, Modal } from "antd";
import axios from "axios";

import { MdRefresh } from "react-icons/md";

const confirm = Modal.confirm;

const DrawerPerfis = ({ utilizadorId, visible, onClose, onUpdate, form }) => {
    const [perfis, setPerfis] = useState([]);
    const [estabelecimentos, setEstabelecimentos] = useState([]);
    const [estabelecimentosExpandidos, setEstabelecimentosExpandidos] = useState([]);
    const [selecionados, setSelecionados] = useState([]);
    const [iconLoading, setIconLoading] = useState(false);

    const openNotificationWithIcon = (type, message, description) => {
        notification[type]({
            message: message,
            description: description
        });
    };
    const { Panel } = Collapse;

    const listarEstabelecimentos = () => {
        axios({
            method: "get",
            url: "/api/gestao-utilizadores-organismos/listar-estabelecimentos",
            params: {
                utilizadorId
            }
        })
            .then(response => {
                setEstabelecimentos(response.data);
                setSelecionados(
                    response.data.map(x => {
                        return {
                            id: x.id,
                            perfis: []
                        };
                    })
                );
                listarSelecionados();
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    const listarPerfis = () => {
        axios({
            method: "get",
            url: "/api/gestao-perfis/listar",
            params: {
                utilizadorId
            }
        })
            .then(response => {
                setPerfis(response.data);
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    const listarSelecionados = () => {
        axios({
            method: "get",
            url: "/api/gestao-perfis/listar-selecionados",
            params: {
                utilizadorId
            }
        })
            .then(response => {
                setSelecionados(response.data);
            })
            .catch(error => {
                if (error.response.status === 401)
                    this.setState({
                        redirect: true,
                        redirectLink: "/login"
                    });
            });
    };

    const onChangeCollapse = estabelecimentosExpandidos => {
        setEstabelecimentosExpandidos(estabelecimentosExpandidos);
    };

    const onChange = (estabelecimentoId, perfisSelecionados) => {
        const nomeEstabelecimentoSelecionado = estabelecimentos.find(e => e.id === estabelecimentoId).nome;
        const perfisAtuais = selecionados.find(x => x.id === estabelecimentoId).perfis;

        const { tipoOperacao, perfilAlterado } = determinarAlteracao(perfisSelecionados, perfisAtuais);
        const nomePerfil = perfis.find(p => p.id === perfilAlterado).nome;

        if (estabelecimentos.length > 1) {
            mostrarConfirmacao(
                nomeEstabelecimentoSelecionado,
                nomePerfil,
                tipoOperacao,
                () => {
                    guardarPerfilSelecionado(estabelecimentoId, perfisSelecionados);
                },
                () => {
                    guardarPerfilSelecionadoEmTodas(
                        estabelecimentoId,
                        perfilAlterado,
                        tipoOperacao === "removido" ? "remover" : "adicionar"
                    );
                }
            );
        } else {
            guardarPerfilSelecionado(estabelecimentoId, perfisSelecionados);
        }
    };

    const determinarAlteracao = (perfisSelecionados, perfisAtuais) => {
        const foiRemovido = perfisSelecionados.length < perfisAtuais.length;

        return {
            tipoOperacao: foiRemovido ? "removido" : "selecionado",
            perfilAlterado: foiRemovido
                ? perfisAtuais.find(p => !perfisSelecionados.includes(p.id)).id
                : perfisSelecionados.find(psId => !perfisAtuais.some(p => p.id === psId))
        };
    };

    const mostrarConfirmacao = (nomeEstabelecimento, nomePerfil, tipoOperacao, onApenasUm, onTodas) => {
        const totalEstabelecimentos = estabelecimentos.length;

        confirm({
            title: `Perfil ${nomePerfil} ${tipoOperacao}`,
            content: (
                <>
                    <div>Aplicar a todas as escolas?</div>
                    <div>Este utilizador está associado a {totalEstabelecimentos} escolas.</div>
                </>
            ),
            okText: `Apenas ${nomeEstabelecimento}`,
            okType: "Cancelar",
            cancelText: "Aplicar a todas",
            onOk: onApenasUm,
            onCancel: onTodas
        });
    };

    const guardarPerfilSelecionado = (estabelecimentoId, perfisSelecionados) => {
        let tempSelecionados = selecionados.filter(x => x.id !== estabelecimentoId);
        let tempSelecionado = selecionados.find(x => x.id === estabelecimentoId);

        const principalAnterior = tempSelecionado.perfis.find(p => p.principal && perfisSelecionados.includes(p.id));
        tempSelecionado.perfis = perfisSelecionados.map((perfilId, index) => ({
            id: perfilId,
            principal: principalAnterior ? perfilId === principalAnterior.id : index === 0
        }));

        setSelecionados([...tempSelecionados, tempSelecionado]);
    };

    const guardarPerfilSelecionadoEmTodas = (estabelecimentoId, perfilId, operacao) => {
        const _estabelecimentos = selecionados.map(estabelecimento => {
            let estabelecimentoPerfis = estabelecimento.perfis;

            if (operacao === "remover") {
                estabelecimentoPerfis = estabelecimentoPerfis.filter(p => p !== perfilId);
            } else {
                if (!estabelecimentoPerfis.some(p => p.id === perfilId)) {
                    const perfilInfo = {
                        id: perfilId,
                        principal: false
                    };

                    estabelecimentoPerfis = [...estabelecimentoPerfis, perfilInfo];
                }
            }

            estabelecimento.perfis = estabelecimentoPerfis;

            return estabelecimento;
        });

        setSelecionados(_estabelecimentos);
    };

    const replicarPerfis = (e, estabelecimentoId) => {
        e.stopPropagation();

        confirm({
            title: "Pretende replicar os perfis deste estabelecimento para todos os outros?",
            okText: "Aplicar",
            okType: "Cancelar",
            onOk: () => aplicarPerfis(estabelecimentoId)
        });
    };

    const aplicarPerfis = estabelecimentoId => {
        const estabelecimento = selecionados.find(x => x.id === estabelecimentoId);
        const perfis = estabelecimento.perfis;

        setSelecionados(selecionados.map(x => ({ ...x, perfis })));
    };

    const confirma = () => {
        if (validarPerfis(selecionados)) {
            setIconLoading(true);
            var item = new FormData();
            item.append("id_utilizador", utilizadorId);
            item.append("estabelecimentos", JSON.stringify(selecionados));

            axios({
                method: "put",
                url: "/api/gestao-perfis/alterar",
                data: item
            })
                .then(response => {
                    setIconLoading(false);
                    openNotificationWithIcon("success", "Sucesso", "Perfis guardados");
                    onUpdate();
                })
                .catch(error => {
                    if (error.response.status === 401)
                        this.setState({
                            redirect: true,
                            redirectLink: "/login"
                        });
                    setIconLoading(false);
                    openNotificationWithIcon("error", "Erro", error.response.data);
                });
        } else {
            openNotificationWithIcon("error", "Erro", "Não foram selecionados estabelecimentos!");
        }
    };

    const validarPerfis = estabelecimentos => {
        let todosTemPerfis = true;

        estabelecimentos.forEach(estabelecimento => {
            if (estabelecimento.perfis.length === 0) {
                todosTemPerfis = false;
            }
        });

        return todosTemPerfis;
    };

    const marcarComoPrincipal = (estabelecimentoId, perfilId) => {
        let tempSelecionados = selecionados.filter(x => x.id !== estabelecimentoId);
        let tempSelecionado = selecionados.find(x => x.id === estabelecimentoId);

        let tempPerfisSelecionados = tempSelecionado.perfis
            .filter(x => x.id !== perfilId)
            .map(sel => {
                return {
                    id: sel.id,
                    principal: false
                };
            });
        const selecionado = {
            id: perfilId,
            principal: true
        };

        tempSelecionado.perfis = [...tempPerfisSelecionados, selecionado];
        setSelecionados([...tempSelecionados, tempSelecionado]);
    };

    const montrarBotaoCheck = (estabelecimentoId, perfil) => {
        const estabelecimento = selecionados.find(x => x.id === estabelecimentoId);
        const selecionado = estabelecimento?.perfis.find(x => x.id === perfil.id);

        if (selecionado) {
            if (selecionado.principal)
                return (
                    <Link className="botao-icon-check" to="#" title="Por defeito" onClick={event => event.stopPropagation()}>
                        <Icon type="check" />
                    </Link>
                );
            else
                return (
                    <Link
                        className="botao-icon-uncheck"
                        to="#"
                        title="Marcar perfil por defeito"
                        onClick={event => {
                            event.stopPropagation();
                            marcarComoPrincipal(estabelecimentoId, perfil.id);
                        }}
                    ></Link>
                );
        } else {
            return (
                <Link
                    className="botao-icon-uncheck"
                    to="#"
                    title="Marcar perfil por defeito"
                    style={{ cursor: "default" }}
                    onClick={event => event.stopPropagation()}
                ></Link>
            );
        }
    };

    const afterVisibleChange = visible => {
        form.resetFields();
        if (visible) {
            listarPerfis();
            listarEstabelecimentos();
        } else {
            setEstabelecimentosExpandidos([]);
        }
    };

    const isBotaoDesativado = selecionados.some(s => !s.perfis || s.perfis.length === 0);

    return (
        <Drawer
            className="drawer-inscrever drawer-perfis"
            //title="Selecionar Perfis"
            width={720}
            onClose={onClose}
            visible={visible}
            style={{
                overflow: "auto",
                height: "calc(100% - 108px)",
                paddingBottom: "108px"
            }}
            maskClosable={false}
            afterVisibleChange={afterVisibleChange}
        >
            <div className="bloco-drawer-associar">
                <div className="bloco">
                    <h3 className="titulo-separador">Lista</h3>
                    <Collapse
                        defaultActiveKey={[]}
                        activeKey={estabelecimentosExpandidos}
                        onChange={onChangeCollapse}
                        style={{ border: "none" }}
                    >
                        {estabelecimentos.map(estabelecimento => (
                            <Panel
                                header={
                                    <span style={{ display: "flex", justifyContent: "space-between", alignContent: "center" }}>
                                        <span>{estabelecimento.nome}</span>
                                        <span style={{ display: "flex", gap: 5 }}>
                                            {estabelecimentos.length > 1 && (
                                                <Link
                                                    to="#"
                                                    style={{ display: "flex", alignItems: "center", color: "#f79071" }}
                                                    onClick={e => replicarPerfis(e, estabelecimento.id)}
                                                >
                                                    <MdRefresh />
                                                    Replicar perfis
                                                </Link>
                                            )}
                                            <span>Principal</span>
                                        </span>
                                    </span>
                                }
                                key={estabelecimento.id}
                            >
                                <Checkbox.Group
                                    className="lista-estabelecimentos"
                                    style={{ width: "100%" }}
                                    value={selecionados.find(x => x.id === estabelecimento.id)?.perfis.map(x => x.id)}
                                    onChange={sels => onChange(estabelecimento.id, sels)}
                                >
                                    {perfis.map(perfil => (
                                        <div key={perfil.id} style={{ marginBottom: "20px" }}>
                                            <Checkbox value={perfil.id}>
                                                {perfil.nome}
                                                {montrarBotaoCheck(estabelecimento.id, perfil)}
                                            </Checkbox>
                                        </div>
                                    ))}
                                </Checkbox.Group>
                            </Panel>
                        ))}
                    </Collapse>
                </div>
            </div>
            <div className="ant-drawer-footer">
                <button className="botao-secundario" onClick={onClose} style={{ marginRight: 20, display: "inline-block" }}>
                    Voltar
                </button>
                <button className="botao-principal" disabled={iconLoading || isBotaoDesativado} type="primary" onClick={confirma}>
                    {iconLoading ? <Icon type="loading" /> : null}
                    Salvar
                </button>
            </div>
        </Drawer>
    );
};
const FormDrawerPerfis = Form.create({ name: "drawer-perfis" })(DrawerPerfis);

export default FormDrawerPerfis;
